import _ from 'lodash'

const Pagination = {
  data: () => ({
    query: {},
    pagination: null,
    page: 1,
    pageSize: 5,
    pageCount: 0,
    allItems: [],
    items: [],
    copiedItems: []
  }),
  methods: {
    optionTableData ($event, direction) {
      // First request make here, because mount to trigger earlier.
      // We have to waiting for table pagination params.

      this.addUrlParam({
        PageSize: $event.itemsPerPage,
        PageIndex: 0, // +localStorage.getItem('patientPaginationPageIndex') || $event.page || 1,
        order: [
          {
            column: 'name',
            direction: direction || 'desc'
          }
        ]
      })
      if ($event.sortBy.length) {
        this.addUrlParam({
          PageSize: this.currentPageSize || 15, // $event.page,
          PageIndex: 0,
          order: [
            {
              column: $event.sortBy[0],
              direction: ($event.sortDesc[0]) ? 'desc' : 'asc'
            }
          ]
        })
      }
      this[this.getAllFunc]({...this.query, PageSize: this.currentPageSize || 15 })
    },
    addUrlParam (params) {
      this.$set(this.$data, 'query', { ...this.query, ...params })
    },
    removeUrlParam (param) {
      const query = this.query
      if (query[param]) {
        delete query[param]
        this.$set(this.$data, 'query', query)
      }
    },
    removeAllUrlParam () {
      this.$set(this.$data, 'query', '')
    },
    removeAllUrlParamExept (params) {
      const query = this.query
      for (const key in query) {
        if (key && !params.includes(key)) {
          delete query[key]
        }
      }
      this.$set(this.$data, 'query', query)
    },
    getQuery () {
      return this.query
    },
    setupPagination (allItems) {
      this.allItems = _.chunk(allItems, this.pageSize)
      this.pageCount = _.size(this.allItems)
      this.items = this.allItems[this.page - 1] || this.allItems[0]
      this.copiedItems = this.items
    },
    changeItermPerPage ($event, allItems) {
      this.pageSize = $event
      this.setupPagination(allItems)
    },
    changePagination ($event) {
      this.page = $event
      this.items = this.allItems[this.page - 1] || this.allItems[0]
      this.copiedItems = this.items
    }
  }
}

export default Pagination
